import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import HomeApplianceGeneralGlassesBG from "../../../Assets/Product_Images/HomeApplliences&GenralUse/HomeAppliance&GeneralGlassesBG.jpg";
import HomeApplianceGeneralGlasses1 from "../../../Assets/Product_Images/HomeApplliences&GenralUse/HomeAppliance&GeneralGlasses1.jpeg";
import HomeApplianceGeneralGlasses2 from "../../../Assets/Product_Images/HomeApplliences&GenralUse/HomeAppliance&GeneralGlasses2.jpeg";
import HomeApplianceGeneralGlasses3 from "../../../Assets/Product_Images/HomeApplliences&GenralUse/HomeAppliance&GeneralGlasses3.jpeg";
import HomeApplianceGeneralGlasses4 from "../../../Assets/Product_Images/HomeApplliences&GenralUse/HomeAppliance&GeneralGlasses4.webp";
import HomeApplianceGeneralGlasses5 from "../../../Assets/Product_Images/HomeApplliences&GenralUse/HomeAppliance&GeneralGlasses5.jpeg";
import HomeApplianceGeneralGlasses6 from "../../../Assets/Product_Images/HomeApplliences&GenralUse/HomeAppliance&GeneralGlasses6.jpeg";
import { Link } from "react-router-dom";

const Home_Appliance_glasses = () => {
  return (
    <div>
      <Header />
      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${HomeApplianceGeneralGlassesBG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>{" "}
                  / <span className="text-white">Home Appliance & General Street glasses</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* about tabbing section start  */}
      <section className="container-fluid about_Products_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="blog_text wow fadeInUp">
                <h5
                  style={{
                    color: "#153fa4",
                    fontFamily: "Segoe UI, sans-serif",
                    fontSize: "40px",
                    fontWeight: "700",
                    marginBottom: "15px",
                  }}
                >
                 Home Appliance & General Street glasses
                </h5>
                <p>
                  Glass used in household gadgets is especially made for
                  aesthetics, heat resistance, and toughness. Usually seen in
                  cooktops, oven doors, microwave panels, refrigerator shelves,
                  and microwave panels. Often tempered or laminated, these
                  glasses are made to resist the heat and mechanical stress from
                  daily domestic use.
                </p>
                <p>
                  Heat treatment of tempered glass in ovens and cooktops enables
                  it to resist thermal expansion and rapid temperature changes,
                  therefore preventing fractures and damage. Toughened glass
                  shelves in refrigerators offer a sleek appearance and
                  strength. Ideal for kitchen use, this kind of glass is also
                  simple to clean and stain-resistant.
                </p>
                <p>
                  Glass is not only useful in contemporary products; it's also
                  part of the design allure. Modern kitchens and living areas'
                  visual beauty is enhanced by touchscreen control panels,
                  glossy glass surfaces, and transparent or colored panels.
                  Glass combined with touch or display technology is becoming a
                  critical component as smart homes spread.
                </p>

                <p>
                  <strong>Key Features:</strong>
                </p>
                <ul>
                  <li>Break and crack resistance</li>
                  <li>High durability under stress</li>
                  <li>Smooth, optimum finish</li>
                </ul>
              </div>
              <div className="Products_img gap-5 mt-5 wow fadeInUp">
                <img src={HomeApplianceGeneralGlasses1} style={{width : "180px" , height : "180px"}} alt="Bus" />
                <img src={HomeApplianceGeneralGlasses2} style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={HomeApplianceGeneralGlasses3} style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={HomeApplianceGeneralGlasses4} style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={HomeApplianceGeneralGlasses5} style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={HomeApplianceGeneralGlasses6} style={{width : "180px" , height : "180px"}} alt="car" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End */}

      <Footer />
    </div>
  );
};

export default Home_Appliance_glasses;
